import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'sort',
  version: '1.0.0',
  properties: [
    {
      key: 'inputArray',
      label: 'Input Array',
      type: 'string',
      required: true,
      placeholder: 'e.g., {{ $node["Data Engine API"].output.data }}',
      description: 'The array to sort. Drag from the input panel or type the path.',
      default: '',
    },
    {
      key: 'sortFields',
      label: 'Sort Fields',
      type: 'fixedCollection',
      required: true,
      typeOptions: {
        multipleValues: true,
      },
      default: {
        values: [
          {
            field: '',
            order: 'ascending',
          },
        ],
      },
      fixedCollectionOptions: [
        {
          name: 'values',
          displayName: 'Sort Field',
          description: 'Add fields to sort by (in priority order)',
          values: [
            {
              key: 'field',
              label: 'Field',
              type: 'options',
              required: true,
              placeholder: 'Select a field',
              description: 'The field name to sort by',
              options: [],
              typeOptions: {
                // Load field options dynamically from the inputArray parameter
                loadOptionsFrom: 'inputArray',
              },
            },
            {
              key: 'order',
              label: 'Order',
              type: 'options',
              required: true,
              default: 'ascending',
              options: [
                { value: 'ascending', name: 'Ascending (A-Z, 0-9)' },
                { value: 'descending', name: 'Descending (Z-A, 9-0)' },
              ],
            },
          ],
        },
      ],
    },
  ],
};

export default schema;
